module.exports = __webpack_public_path__ + "img/album17_04.e11cacf2.jpg";